import * as colors from "../styles/colors";
import * as docketPropTypes from "../docketPropTypes";
import appStyles from "../styles/appStyles";
import React, { PureComponent } from "react";
import { StyleSheet, css } from "aphrodite";
import { connect } from "react-redux";

const styles = StyleSheet.create({
	link: {
		color: colors.docketLightishBlue,
	},
});

const strings = {
	contactMessage: "If you see this message for more than 15 minutes, please contact our",
	engineeringTeam: "engineering team.",
	unavailableMessage1: "We are busy performing maintenance on the server.",
	unavailableMessage2: "We apologize for any inconvenience this causes you.",
	unsavedMessage1: "If you have any unfinished work, hang tight.",
	unsavedMessage2: "You can try again once server maintenance is over.",
};

class ServiceUnavailableMessage extends PureComponent {
	static propTypes = {
		user: docketPropTypes.user,
	};

	render() {
		return (
			<div>
				<p className={css(appStyles.baseFont)}>
					{strings.unavailableMessage1} {strings.unavailableMessage2}{" "}
					{strings.contactMessage}{" "}
					<a href="mailto:developers@docketnavigator.com" className={css(styles.link)}>
						{strings.engineeringTeam}
					</a>
				</p>
				{this.props.user ? (
					<p className={css(appStyles.baseFont)}>
						{strings.unsavedMessage1} {strings.unsavedMessage2}
					</p>
				) : null}
			</div>
		);
	}
}

const mapStateToProps = state => ({
	user: state.session.currentUser,
});

export default connect(mapStateToProps)(ServiceUnavailableMessage);
